import type { InsuranceProductVersionWithDateFormat, PricingVersionTuple } from '../../model/model.ts'

// Pricing versions for es-rcph were created before we agreed on a unified standard.
// This is why we use a custom format instead of using `PricingVersionFormat`, for retro-compatibility.
type EsRcphPricingVersionFormat = `es-rcph-${number}.${number}-${InsuranceProductVersionWithDateFormat}`

export const esRcphPricingVersions = [
  ['es-rcph-1.0-2024-11-19', { label: 'Version 1' }],
  [
    'es-rcph-1.1-2026-03-13',
    { label: 'Version 1.1 - Rework GL option activation for TECH, travel agencies and security companies' },
  ],
  ['es-rcph-1.2-2026-05-28', { label: 'Version 1.2 - Apply fees and discount rates to the GL product' }],
  ['es-rcph-1.3-2026-06-26', { label: 'Version 1.3 - Apply GL option for all security activity contracts' }],
] as const satisfies PricingVersionTuple<EsRcphPricingVersionFormat>[]

export type EsRcphPricingVersion = (typeof esRcphPricingVersions)[number][0]
